import React, { Component } from 'react';
import Moment from "moment";
let DateTimeField = require("react-bootstrap-datetimepicker");
require("moment/locale/es-mx");

class SelectorFecha extends Component {
    constructor(props) {
        super(props);
    }

    changeDate(calendario,date) {
        const {fArguments} = this.props;
        //cualquier otro argumento que lleve la función de selección de fecha debe enviarse en la prop "fArguments", la fecha se envía por separado en la propiedad "fecha" y en la función de selección va como último argumento
        let functionArgs= fArguments;
        functionArgs.push(date);
        
        if(calendario == "fecha-desde")
            this.props.validarFormatoFechaDesde(date);
        else
            this.props.validarFormatoFechaHasta(date);
    }


    render() {
        let fecha = typeof this.props.fecha == "string" ? this.props.fecha.substr(0,10) : this.props.fecha;
        let errorFormatoFecha = this.props && this.props.errorFormatoFechaDatosCuenta ? ' error-validacion' : '';
        return (
            <div className={this.props.claseContainer ? this.props.claseContainer : ""}
            >
                {!this.props.noLabel && <div className={this.props.classLabel}>{this.props.titulo}</div>}
                        <div key={this.props.keyDate}  className={!this.props.clasePicker ? 'datePickerProcesos' + errorFormatoFecha : this.props.clasePicker + errorFormatoFecha}>
                            <DateTimeField
                                id={this.props.keyDate}
                                key={this.props.keyDate}
                                mode="date"
                                dateTime={fecha}
                                maxDate={this.props.maxToday ? Moment():null}
                                format={"DD/MM/YYYY"}
                                inputFormat={"DD/MM/YYYY"}
                                defaultText={this.props.textoInput}
                                onChange={(e) => this.changeDate(this.props.keyDate,e)}
                            />
                    </div>
            </div>
        );
    }
}

export default SelectorFecha;